export const events = {
  engagementSignalIconClicked: 'Engagement Signal Icon Clicked',
  insightsSummaryColumnSorted: 'Insights Summary Column Sorted',
  insightsSummaryEmployeeRowClicked: 'Insights Summary Employee Row Clicked',
  insightsSummaryExportClicked: 'Insights Summary Export Data Clicked',
  insightsSummaryFilterApplied: 'Insights Summary Filter Applied',
  insightsSummaryScoreBarClicked: 'Insights Summary Performance Score Bar Clicked',
  insightsSummaryTooltipViewed: 'Insights Summary Tooltip Viewed',
  insightsSummaryOpenAnalyticsDashboard: 'Insights Summary Go To Analytics Dashboard',
  insightsSummarySwitchChartClicked: 'Insights Summary Switch Chart Clicked',
  insightsSummaryHeadcountBarClicked: 'Insights Summary Headcount Bar Clicked',
}
